/**
 * The audit event families HR filters the timeline by. The `value`s are the
 * stable kebab-case wire strings the api's `AuditCategory` enum emits and the
 * `?category=` filter accepts — keep them in sync with
 * `services/api/src/audit/registry.py`.
 */
export interface AuditCategoryOption {
  value: string
  /** Dropdown label. */
  label: string
  /** Short chip label shown on each row. */
  chip: string
}

export const AUDIT_CATEGORY_OPTIONS: readonly AuditCategoryOption[] = [
  { value: 'leave-application', label: 'Leave applications', chip: 'Leave' },
  { value: 'leave-credit', label: 'Leave credits', chip: 'Credit' },
  { value: 'employee', label: 'Employees', chip: 'Employee' },
  { value: 'org-structure', label: 'Org structure', chip: 'Org' },
  { value: 'coverage-threshold', label: 'Coverage thresholds', chip: 'Coverage' },
  { value: 'on-behalf-approval', label: 'On-behalf approvals', chip: 'On behalf' },
  { value: 'delegation', label: 'Delegations', chip: 'Delegation' },
  { value: 'import-export', label: 'Import / export', chip: 'Import/Export' },
  { value: 'holiday', label: 'Holidays', chip: 'Holiday' },
  { value: 'blackout', label: 'Blackouts', chip: 'Blackout' },
  { value: 'other', label: 'Other / system', chip: 'System' },
] as const

const _CHIP_BY_VALUE: Record<string, string> = Object.fromEntries(
  AUDIT_CATEGORY_OPTIONS.map((o) => [o.value, o.chip]),
)

/** Short chip label for a category wire value; falls back to the raw value. */
export function auditCategoryChip(category: string): string {
  return _CHIP_BY_VALUE[category] ?? category
}
